import type { ReactNode } from 'react';
import { HorizontalContainer, VerticalContainer } from '@/components';
import { ProfileDesktopMenu } from './ProfileDesktopMenu';

type ProfileLayoutProps = {
    children: ReactNode;
    isAdolescent: boolean;
    hasVeterinarianCoverage: boolean;
};

export const ProfileLayout = ({
    children,
    isAdolescent,
    hasVeterinarianCoverage,
}: ProfileLayoutProps) => (
    <HorizontalContainer
        spacing="none"
        className="md:rounded-2xl md:border md:border-(--color-border-muted)"
    >
        <aside className="hidden md:block md:min-w-72 md:flex-none">
            <ProfileDesktopMenu
                isAdolescent={isAdolescent}
                hasVeterinarianCoverage={hasVeterinarianCoverage}
            />
        </aside>

        <VerticalContainer
            spacing="none"
            className="min-w-0 flex-1 justify-between md:p-8"
        >
            <div className="h-full">{children}</div>
        </VerticalContainer>
    </HorizontalContainer>
);
